import { useContext } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
// eslint-disable-next-line import/no-cycle
import { HotkeysContextV2 } from '.'

export default function useTogglePlayHotkeys() {
  const { playButtonRef } = useContext(HotkeysContextV2)

  useHotkeys(
    ['space'],
    () => {
      playButtonRef?.current?.click()
    },
    {
      preventDefault: true,
    },
  )
}
